<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-remove-button/lecture-remove-button.component.ts.LectureRemoveButtonComponent.html